import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ThermostatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"thermostat"}/>
}
